<script>
import ReturnQuery from 'components/mixins/return-query';

import PageHelp from 'components/pages/professional/shared/help/page-help-overlay';

import * as KEYS from 'constants/keys';
import * as EVENT from 'constants/event';

import NuttremaLoader from 'components/ui/panels/nuttrema-loader';
import NuttremaLayoutDefaultSlide from 'components/ui/layout/nuttrema-layout-default-slide';
import NuttremaIconicaSidebarLink from 'components/ui/label/nuttrema-iconica-sidebar-link';

import NuttremaMenuList from 'components/ui/navigation/nuttrema-menu-list';
import NuttremaMenuListItem from 'components/ui/navigation/nuttrema-menu-list-item';

import SidebarMenuLevelZeroCollapsed from 'components/ui/menu/level-zero/sidebar-menu-level-zero-collapsed';
import SidebarMenuLevelZeroExpanded from 'components/ui/menu/level-zero/sidebar-menu-level-zero-expanded';

import SidebarLinkOverlayUsermenu from 'components/ui/menu/persons/sidebar-link-overlay-usermenu';

import NuttremaBrandImage from 'components/ui/images/nuttrema-brand-image';
import SidebarIconLevelZero from 'components/ui/menu/level-zero/sidebar-icon-level-zero';

export default {
  name: 'abstract-layout-set-details',
  mixins: [ReturnQuery],
  props: {
    index: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      KEYS,
      EVENT,
      show: {
        pageHelp: false,
      },
    };
  },
  components: {
    PageHelp,
    NuttremaLoader,
    NuttremaMenuList,
    NuttremaBrandImage,
    NuttremaMenuListItem,
    SidebarIconLevelZero,
    NuttremaLayoutDefaultSlide,
    NuttremaIconicaSidebarLink,
    SidebarLinkOverlayUsermenu,
    SidebarMenuLevelZeroExpanded,
    SidebarMenuLevelZeroCollapsed,
  },
  methods: {
    matched(name) {
      return this.$route.name === name;
    },
    routerLink(ref, name) {
      const popover = this.$refs[ref];
      if (popover) popover.doClose();
      this.$router.replace({ name });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ui/layout-set/abstract/abstract-layout-set.vue